/**
 * TabbedModal — generador reutilizable de modales con sidebar de tabs.
 *
 * ROBUSTO: toda la visibilidad se maneja con style.display inline.
 * No depende de clases CSS para show/hide — cero ambigüedad de cascada.
 * La clase 'active' es solo visual (highlight del tab), no funcional.
 */
import { icon } from '../utils/icon.js';

export const TabbedModal = {
    /**
     * Genera el HTML del body interior del modal (sidebar + content).
     */
    render({ tabs, panels, defaultTab, modalId }) {
        const first = defaultTab || (tabs.length > 0 ? tabs[0].id : '');

        const tabsHtml = tabs
            .map(
                t => `
            <div class="modal-tab${t.id === first ? ' active' : ''}" data-tab="${t.id}" data-modal="${modalId}">
                ${icon(t.icon)}
                <div class="tab-text">
                    <span class="tab-title">${t.title}</span>
                    <span class="tab-desc">${t.desc}</span>
                </div>
            </div>`
            )
            .join('');

        const panelsHtml = tabs
            .map(
                t =>
                    `<div id="${modalId}-panel-${t.id}" class="tabbed-panel" style="display:${t.id === first ? 'block' : 'none'};">${panels[t.id] || ''}</div>`
            )
            .join('');

        return `
            <div class="modal-tabs">${tabsHtml}</div>
            <div class="modal-content" style="padding:16px; flex:1; overflow-y:auto;">
                ${panelsHtml}
            </div>`;
    },

    /**
     * Cambia el tab activo. Todo via inline display — sin depender de CSS.
     */
    setTab(modalId, tabId) {
        const modal = document.getElementById(modalId);
        if (!modal) return;

        const tabs = modal.querySelectorAll('.modal-tab[data-modal]');
        const panels = modal.querySelectorAll('.tabbed-panel');

        for (let i = 0; i < tabs.length; i++) tabs[i].classList.remove('active');
        for (let i = 0; i < panels.length; i++) panels[i].style.display = 'none';

        const activeTab = modal.querySelector(`.modal-tab[data-tab="${tabId}"]`);
        const activePanel = document.getElementById(`${modalId}-panel-${tabId}`);

        if (activeTab) activeTab.classList.add('active');
        if (activePanel) activePanel.style.display = 'block';
    },
};
